module.exports = __webpack_public_path__ + "static/media/lock.dd6421ee.svg";